/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JobRole } from './JobRole';
import {
    JobRoleFromJSON,
    JobRoleFromJSONTyped,
    JobRoleToJSON,
    JobRoleToJSONTyped,
} from './JobRole';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface ListJobRolesResponse
 */
export interface ListJobRolesResponse {
    /**
     * 
     * @type {Array<JobRole>}
     * @memberof ListJobRolesResponse
     */
    data: Array<JobRole>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListJobRolesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListJobRolesResponse interface.
 */
export function instanceOfListJobRolesResponse(value: object): value is ListJobRolesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListJobRolesResponseFromJSON(json: any): ListJobRolesResponse {
    return ListJobRolesResponseFromJSONTyped(json, false);
}

export function ListJobRolesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListJobRolesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(JobRoleFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListJobRolesResponseToJSON(json: any): ListJobRolesResponse {
      return ListJobRolesResponseToJSONTyped(json, false);
  }

  export function ListJobRolesResponseToJSONTyped(value?: ListJobRolesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(JobRoleToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

